import React, {useState} from 'react';
import {Icon, Transition, TransitionGroup} from 'components';
import {range, usePreviousDistinct} from 'helpers';
import css from './horizontal-scroller.module.scss';

export function HorizontalScroller({ columns, Render, max = 999 }) {
  const [ position, setPosition ] = useState(0);
  const prev = usePreviousDistinct(position);
  return (
    <div className={css.wrapper} style={{ '--size': columns }}>
      <Icon name="chevron-left" onClick={() => setPosition(position-1)} />
      <div className={css.container} style={{ '--direction': (position - prev) / columns }}>
        <div className={css.grid}>
          {range(0, columns).map(index =>
            <div key={index} />
          )}
        </div>
        <TransitionGroup>
          { [ position ].map(position =>
            <Transition key={position} timeout={200}>
              { transition =>
                <div className={getClass(transition)}>
                  {range(0, columns).map(index =>
                    <Render key={index} position={position + index - columns + 1} />
                  )}
                </div>
              }
            </Transition>
          ) }
        </TransitionGroup>
      </div>
      <Icon name="chevron-right" onClick={() => setPosition(position+1)} disabled={position == max} />
    </div>
  );
}

const getClass = transition => {
  if (transition == 'entering') {
    window.pageYOffset; //trigger reflow for animations
  }
  return css('content', transition);
};
